/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const isEqual = (a: any, b: any): boolean => JSON.stringify(a) === JSON.stringify(b)

export const convertDictionaryKeysToLowerCase = <T>(obj: { [key: string]: T }): { [key: string]: T } =>
  Object.keys(obj).reduce((acc: any, key: string) => {
    acc[key.toLocaleLowerCase()] = obj[key]
    return acc
  }, {})
